import React from "react";
import { Box, Container, Typography, Divider, Link as MUILink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

export const LegalLayout = ({ title, lastUpdated, intro, children }) => (
  <Box sx={{ backgroundColor: "#fff" }}>
    <Container maxWidth="md" sx={{ pt: { xs: 16, md: 14 }, pb: { xs: 6, md: 8 } }}>
      <Typography
        variant="h3"
        fontWeight="bold"
        sx={{ color: "#e3242b", fontSize: { xs: "2rem", md: "2.75rem" } }}
      >
        {title}
      </Typography>
      {lastUpdated && (
        <Typography sx={{ color: "text.secondary", mt: 1 }}>
          Last updated: {lastUpdated}
        </Typography>
      )}
      <Divider sx={{ my: 3 }} />
      {intro && (
        <Typography sx={{ mb: 3, lineHeight: 1.8 }}>{intro}</Typography>
      )}
      {children}
    </Container>
  </Box>
);

export const Section = ({ heading, children }) => (
  <Box sx={{ mt: 4 }}>
    {heading && (
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1.5 }}>
        {heading}
      </Typography>
    )}
    {children}
  </Box>
);

export const Paragraph = ({ children }) => (
  <Typography sx={{ mb: 2, lineHeight: 1.8, color: "text.primary" }}>
    {children}
  </Typography>
);

export const BulletList = ({ items }) => (
  <Box component="ul" sx={{ pl: 3, mb: 2 }}>
    {items.map((item, i) => (
      <Typography key={i} component="li" sx={{ mb: 1, lineHeight: 1.8 }}>
        {item}
      </Typography>
    ))}
  </Box>
);

export const LegalPageLink = ({ to, children }) => (
  <MUILink component={RouterLink} to={to} sx={{ color: "#e3242b", fontWeight: 600 }}>
    {children}
  </MUILink>
);
